<template>
  <div>
    <!--取消收藏弹框-->
    <!-- v-model="NoCollectModel" -->
    <Modal class="no-login-box" :value.sync="NoCollectModel" :closable="false" :scrollable="true" :footer-hide="true"
      :styles="{ top: '300px' }" width="300">
      <p class="item-close" @click="close()">
        <img src="/static/img/popup/close.png" alt="" />
      </p>
      <p class="item-img">
        <img src="/static/img/popup/icon_collect_2.png" alt="" />
      </p>
      <p class="item-txt-1">取消收藏</p>
      <p class="item-txt-2">您已经取消该商品加入您的收藏夹</p>
      <div class="item-button" @click="close()">确定</div>
    </Modal>
    <!--取消收藏弹框-->
  </div>
</template>

<script>
export default {
  name: "NoCollect",
  props: {
    NoCollectModel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // NoCollectModel: true
    };
  },
  methods: {
    close() {
      this.$emit("update:NoCollectModel", false);
    }
  }
};
</script>

<style lang="less" scoped>
.no-login-box {
  text-align: center;

  .item-close {
    width: 20px;
    height: 20px;
    position: absolute;
    right: -14px;
    top: -25px;
    cursor: pointer;
  }

  .item-img {
    width: 148px;
    height: 81px;
    margin: 37px auto auto auto;
  }

  .item-txt-1 {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    padding-top: 18px;
  }

  .item-txt-2 {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666;
    padding-top: 6px;
  }

  .item-button {
    display: block;
    width: 250px;
    height: 40px;
    background: linear-gradient(314deg, #53A401 0%, #6AD200 100%);
    box-shadow: 0px 3px 12px 1px rgba(81, 136, 0, 0.3);
    border-radius: 20px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 40px;
    margin: 35px auto auto auto;
    cursor: pointer;
  }
}

.no-login-box /deep/ ivu-modal {}

.no-login-box /deep/ .ivu-modal-content {
  position: relative;
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/NoCollect.vue